import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Banner } from './resuable-components/banner/banner';
import { Footer } from './resuable-components/footer/footer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Banner, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('thq-content-template');
}
